import React, { useEffect, useRef, useState } from 'react';
import { confirmable, createConfirmation, ConfirmDialogProps } from 'react-confirm';
import { Dropdown, Modal, Button } from 'bootstrap';

const Confirmation = ({ show, proceed, message }) => (
	<div className={`dialog-overlay ${show ? "show" : "hide"}`}>
		<div className="dialog">
			<h2 className="fw-bold fs-5">{message}</h2>
			<div className="d-flex justify-content-end mt-4">
				<button className="btn btn-primary me-3" onClick={() => proceed(true)}>Sì, procedi</button>
				<button className="btn btn-primary" style={{backgroundColor: "#ddd !important"}} onClick={() => proceed(false)}>No</button>
			</div>
			
		</div>
	</div>
)

export const confirm = createConfirmation(confirmable(Confirmation))
